<template>
  <div>
    <Header />
    <div class="mask2" v-if="loading">
        <div class="sub">
          <img src="@/assets/img/Spinner-1s-50px.svg" alt="">
        </div>
      </div>
    <div class="y-vdideo" v-for="val in videoList" :key="val.id">
      <dl class="vdieo-img">
        <dd>
          <video  :poster="val.imageLink" controls="true" controlslist="nodownload" >
            <source :src="val.videoLink" type="video/mp4">
          </video>
        </dd>
        <dt>
          {{val.name}}
        </dt>
      </dl>
    </div>

    <!-- 底部线条 -->
    <div class="code-bar">
    </div>
    <!-- 底部 -->
    <Concatc />
  </div>
</template>

<script>
import Header from '@/components/header/header';
import Concatc from '@/components/concatc/concatc';
import $ from "jquery";
import CONSTANT from '@/constant/constant.js';
import common from '@/common.js';
export default {
  components: {
    Header,
    Concatc
  },
  data(){
    return{
      videoList:[],
      loading:true,
    }
  },
  mounted() {
    var u=0//标记上一个视频
    var video=document.querySelectorAll('video')//获取页面中所有video
        for(let v=0 ;v < video.length ;v++){
            video[v].onclick=function(){
            video[u].pause()//让上一个video暂停
            video[u].currentTime=0//让上一个video播放进度回到0
            video[v].play()//让当前点击的video播放
            u=v //让当前数赋值给u
        }
    }
    this.getVideoInfo();
  },
  methods:{
    // 获取视频列表
    getVideoInfo(){
      let url = CONSTANT.PRODUCTMANAGE.LIST;
      common.postNoSess(url, null,null, res => {
        console.log(res);
        this.videoList = res.data.bussData;
        this.loading = false;
      })
    },
  },
}
</script>

<style lang="less" scope>
@import url('./video.less');
</style>
